import { ValidationMessage } from '@eppendorf/vnls-react-components';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import './monitoring-parameter-form-errors-snapshot.scss';
import {
  ThresholdsFormProfileSnapshot,
  ThresholdsFormErrorTypesSnapshot,
} from './thresholds-form-profile-snapshot';

export function MonitoringParameterFormErrorsSnapshot() {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useFormContext<ThresholdsFormProfileSnapshot>();

  const hasLimitErrors = Object.keys(errors).some(
    (key) =>
      errors[key as keyof ThresholdsFormProfileSnapshot]?.type ===
      ThresholdsFormErrorTypesSnapshot.limits,
  );

  return (
    Object.keys(errors).length > 0 && (
      <div className="monitoring-parameter-form-errors border-solid bg-white border-radius-m border-s border-color-red-500 p-m">
        {hasLimitErrors && (
          <ValidationMessage className="font-weight-bold font-size-m">
            <Trans i18nKey="alertThresholds.limitsError" components={{ br: <br /> }} />
          </ValidationMessage>
        )}

        {errors.root && (
          <ValidationMessage className="font-weight-bold font-size-m">
            {t('errors.unexpected')}
          </ValidationMessage>
        )}
      </div>
    )
  );
}
